import { render, staticRenderFns } from "./NImage.vue?vue&type=template&id=e34d91e0"
import script from "./NImage.vue?vue&type=script&lang=js"
export * from "./NImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports